// extracted by mini-css-extract-plugin
export default {"componentWrapper":"HtmlBlock_componentWrapper__6VFL8","title":"HtmlBlock_title__n4VIl"};